import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

export const CourseCard = ({ 
  title, 
  description, 
  image, 
  icon: Icon, 
  link, 
  ageRange,
  accentColor = 'burgundy'
}) => {
  const colorClasses = {
    burgundy: 'bg-burgundy group-hover:bg-burgundy-600',
    coral: 'bg-coral group-hover:bg-coral-600',
    teal: 'bg-teal group-hover:bg-teal-600'
  };

  return (
    <motion.div
      whileHover={{ y: -8 }}
      transition={{ duration: 0.3 }}
      className="group"
    >
      <Link
        to={link}
        className="block bg-white rounded-3xl shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100"
        data-testid={`course-card-${title.toLowerCase().replace(/\s/g, '-')}`}
      >
        {/* Image */}
        <div className="relative h-48 overflow-hidden">
          <img
            src={image}
            alt={`${title} à Périgueux - École de Musique Pour Tous`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
          
          {/* Icon Badge */}
          {Icon && (
            <div className={`absolute top-4 right-4 w-12 h-12 rounded-full flex items-center justify-center transition-colors ${colorClasses[accentColor]}`}>
              <Icon className="w-6 h-6 text-white" />
            </div>
          )}

          {/* Age Range */}
          {ageRange && (
            <div className="absolute bottom-4 left-4 px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full text-sm font-semibold text-gray-700">
              {ageRange}
            </div>
          )}
        </div>

        {/* Content */}
        <div className="p-6">
          <h3 className="font-dancing text-2xl text-burgundy mb-2 group-hover:text-burgundy-600 transition-colors">
            {title}
          </h3>
          <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-2">
            {description}
          </p>
          <div className="flex items-center text-burgundy font-semibold text-sm group-hover:text-coral transition-colors">
            <span>En savoir plus</span>
            <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-2 transition-transform" />
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
